// src/components/Login.js
import React, { useRef, useState, useEffect } from 'react';
import { Form, Button, Message, Segment, Header, Container } from 'semantic-ui-react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';

export default function Login() {
  const emailRef = useRef();
  const passwordRef = useRef();
  const { login, currentUser, signInWithGoogle } = useAuth();
  const navigate = useNavigate();

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Redirect authenticated user to dashboard
  useEffect(() => {
    if (currentUser) {
      navigate('/dashboard');
    }
  }, [currentUser, navigate]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setError('');
      setLoading(true);
      await login(emailRef.current.value, passwordRef.current.value);
      navigate('/dashboard'); // Redirect to dashboard after successful login
    } catch {
      setError('Failed to log in');
    }

    setLoading(false);
  };

  return (
    <Container text>
      <Segment padded style={{ marginTop: '7em' }}>
        <Header as="h2" textAlign="center">
          Log In
        </Header>
        <Form onSubmit={handleSubmit} error={!!error}>
          <Form.Field required>
            <label>Email</label>
            <input type="email" ref={emailRef} placeholder="Enter your email" required />
          </Form.Field>
          <Form.Field required>
            <label>Password</label>
            <input type="password" ref={passwordRef} placeholder="Enter your password" required />
          </Form.Field>
          {error && <Message error header="Error" content={error} />}
          <Form.Field >
            <Button primary type="submit" fluid loading={loading} disabled={loading}>
              Log In
            </Button>
          </Form.Field>
          <Form.Field >
            <Button color="google plus" onClick={signInWithGoogle} fluid>
              <i className="google icon" />
              Sign in with Google
            </Button>
          </Form.Field>
        </Form>
        <Message>
          Need an account? <Link to="/signup">Sign Up</Link>
        </Message>
      </Segment>
    </Container>
  );
}
